import {Injectable, Inject} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Spot, Guide, Category} from '../core/model';
import {WindowService} from './window.service';
import {BackendService} from './backend.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class GuideService {

  private guideId: string;
  private guide: Guide;
  private guidJsonBackendResponse: Observable<Response>;

  constructor(private backendService: BackendService, @Inject(WindowService) private _window: Window) {
    this.guideId = _window['guideId'];
  }

  public getActiveGuide(): Promise<Guide> {
    return new Promise((resolve, reject) => {
      if (this.guide !== undefined) {
        resolve(this.guide);
      } else {
        this.loadGuideJsonFromBackend().then(json => {
          if (this.guide === undefined) {
            this.guide = this.extractGuide(json);
          }
          resolve(this.guide);
        }).catch(error => reject(error));
      }
    });
  }

  public getCategories(): Promise<Array<Category>> {
    return new Promise((resolve, reject) => {
      this.getActiveGuide().then(guide =>
        resolve(guide.categories)
      ).catch(error => reject(error));
    });
  }

  public loadGuideJsonFromBackend(): Promise<any> {
    if (this.guidJsonBackendResponse === undefined) {
      this.guidJsonBackendResponse = this.backendService.loadGuideJson(this.guideId);
    }
    return new Promise((resolve, reject) => {
      this.guidJsonBackendResponse.forEach(value => {
        const json = value.json();
        resolve(json);
      });
    });
  }

  public saveGuideAsJson(guideJson: string): void {
    this.backendService.updateGuide(this.guideId, guideJson);
  }

  private extractGuide(json): Guide {

    const guide: Guide = {} as Guide;
    guide._id = json._id;
    guide.title = json.title;
    guide.subtitle = json.subtitle;
    guide.mapcenter = json.mapcenter;
    guide.map_server = json.map_server;
    guide.map_attribution = json.map_attribution;
    const categories = this.extractCategories(json);
    guide.categories = Object.keys(categories).map(function (key) {
      return categories[key];
    });

    const spots = [];
    if (json.spots !== undefined) {
      json.spots.forEach(spotJson => {
        const spot: Spot = {} as Spot;
        spot._id = spotJson._id;
        spot.name = spotJson.name;
        spot.description = spotJson.description;
        if (spotJson.geolocation !== undefined) {
          spot.geolocation = spotJson.geolocation;
          spot.category = categories[spotJson.category];
          spots.push(spot);
        }
      });
    }
    guide.spots = spots;
    return guide;
  }

  private extractCategories(json) {
    const categories = {};
    json.categories.forEach(categoryJson => {
      categories[categoryJson.name] = this.extractCategory(categoryJson);
    });
    return categories;
  }

  private extractCategory(categoryJson) {
    const category: Category = {} as Category;
    category.name = categoryJson.name;
    category.markerUrl = categoryJson.markerurl;
    category.color = categoryJson.color;
    category.icon = categoryJson.icon;
    return category;
  }

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/services/guide.service.ts